// extracted by mini-css-extract-plugin
export default {"addon":"_23a2a8ac654686e82739be2deb2a5b63"};